import { render, staticRenderFns } from "./LabelDropdown.vue?vue&type=template&id=7e113874&scoped=true&"
import script from "./LabelDropdown.vue?vue&type=script&lang=js&"
export * from "./LabelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LabelDropdown.vue?vue&type=style&index=0&id=7e113874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e113874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e113874')) {
      api.createRecord('7e113874', component.options)
    } else {
      api.reload('7e113874', component.options)
    }
    module.hot.accept("./LabelDropdown.vue?vue&type=template&id=7e113874&scoped=true&", function () {
      api.rerender('7e113874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/label/LabelDropdown.vue"
export default component.exports